<template>
  <div class="card-body" :style="backgroundStyle">
    <div class="title">{{ title }}</div>
    <div class="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: "WinCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.imageUrl})`,
        backgroundPosition: this.windowWidth <= 744 ? "0 50%" : "50% 0",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      };
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>
.card-body {
  width: 540px;
  height: 395px;
  border-radius: 20px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 130px 60px 60px 60px;
  box-sizing: border-box;
  gap: 20px;
}
.title {
  font-size: 25px;
  font-weight: 500;
}
.text {
  font-size: 14px;
  font-weight: 400;
}

@media (max-width: 1280px) {
  .card-body {
    width: 390px;
    height: 458px;
    padding: 130px 40px 60px 40px;
  }
}

@media (max-width: 1024px) {
  .card-body {
    width: 305px;
    height: 528px;
    padding: 130px 30px 50px 30px;
  }
}
@media (max-width: 880px) {
  .card-body {
    width: 100%;
    height: 294px;
    padding: 130px 40px 40px 40px;
    gap: 14px;
  }
  .text {
    font-size: 12px;
  }
}
@media (max-width: 588px) {
  .card-body {
    width: 100%;
    height: 312px;
    padding: 130px 40px 40px 40px;
  }
}
@media (max-width: 431px) {
  .card-body {
    width: 100%;
    height: 330px;
    padding: 120px 30px 40px 30px;
  }
}
</style>
